(function () {
    'use strict';

    function milestoneModalService($uibModal, myProfileDataService) {
        function openModal(milestonesAndTemplates) {
            var modalInstance = $uibModal.open({
                templateUrl: 'dashboards/partials/milestoneModal.html',
                controller: 'milestoneModalController',
                resolve: {
                    milestonesAndTemplates: function () {
                        return milestonesAndTemplates;
                    }
                },
                windowClass: 'milestone-modal'
            });

            return modalInstance.result.then(function (completedMilestoneNames) {
                if (completedMilestoneNames.length > 0) {
                    myProfileDataService.updateMilestones(completedMilestoneNames).then(function (data) {
                        // do nothing for now
                    });
                }
            });
        }

        function getMilestonesAndTemplates(milestones) {
            return myProfileDataService.loadMyProfile().then(function (profile) {
                var milestonesAndTemplates = [];
                milestones.forEach(function(milestone) {
                    if (profile.Milestones.indexOf(milestone) === -1 &&
                        profile.MilestonesAndLinkedTemplateIds &&
                        profile.MilestonesAndLinkedTemplateIds[milestone]) {
                        // add milestone to collection for milestone modal
                        milestonesAndTemplates.push({
                            milestoneName: milestone,
                            templateId: profile.MilestonesAndLinkedTemplateIds[milestone]
                        });
                    }
                });

                return milestonesAndTemplates;
            });
        }

        return {
            openModal: openModal,
            getMilestonesAndTemplates: getMilestonesAndTemplates
        };
    }

    milestoneModalService.$inject = ['$uibModal', 'myProfileDataService'];

    angular.module('ecap.common').service('milestoneModalService', milestoneModalService);
})();
